import { FC } from 'react'
import { PropTypes } from '@material-ui/core'
import MuiButton, { ButtonProps } from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyle = makeStyles(() => ({
  greyButton: {
    color: 'white',
    backgroundColor: '#bbbbbb',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#aaaaaa',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
}))

type OmitColorButtonProps = Omit<ButtonProps, 'color'>

export interface CustomButtonProps extends OmitColorButtonProps {
  color?: PropTypes.Color | 'grey'
}

const Button: FC<CustomButtonProps> = (props) => {
  const {
    classes: classesProp,
    className,
    color: colorProp = 'default',
    ...buttonProps
  } = props

  const classes = useStyle()

  const color = colorProp === 'grey' ? 'default' : colorProp

  return (
    <MuiButton
      color={color}
      {...buttonProps}
      className={clsx(
        {
          [classes.greyButton]: colorProp === 'grey',
        },
        className,
      )}
      disableElevation
      classes={classesProp}
    />
  )
}

export default Button
